import { useState } from 'react';
import { Button, Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton } from '~/commonComponents';
import { useCreateLocumTenensMutation } from '~/domain/Jobs';
import { Colors } from '../themes/colors';

export default function LocumTenensDentist() {
  const { mutate: createLocumTenens } = useCreateLocumTenensMutation();
  const [text, setText] = useState('');

  const onSubmit = (event) => {
    event.preventDefault();
    createLocumTenens(text);
    setText('');
  };

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Request A Locum Tenens Dentist" />
      <Screen.Body style={{ alignItems: 'center' }}>
        <form
          id="locum-tenens-dentist-form"
          onSubmit={onSubmit}
          style={{ width: '60%', display: 'flex', flexDirection: 'column' }}
        >
          <Typography bold color={colors.neutral[600]} style={{ marginTop: 24, marginBottom: 24 }}>
            GoTu now offers Locum Tenens Dentists to help you fill your open shifts fast.
          </Typography>

          <Typography size="heading_4" bold color={colors.primary[500]} style={{ marginBottom: 8 }}>
            How it works
          </Typography>
          <Typography color={colors.neutral[600]} style={{ marginBottom: 32 }}>
            If your office needs a Locum Tenens Dentist for days, weeks, or months, we’ll help you
            find the right match.
          </Typography>

          <Typography bold color={colors.neutral[600]} style={{ marginBottom: 12 }}>
            For more information tell us what you are looking for below or contact us now.
          </Typography>

          <textarea
            placeholder="Ex: We are looking to hire a Locum Tenens Dentist, for 3 months starting in July. Please text/call me at 555-555-5555 and ask for Sarah."
            style={{
              width: '100%',
              height: 192,
              boxSizing: 'border-box',
              border: '1px solid transparent',
              borderRadius: 10,
              padding: '20px 30px',
              fontFamily: 'Nunito',
              fontSize: 16,
              resize: 'vertical',
              backgroundColor: Colors.neutral_50,
              boxShadow: 'inset 0px 2px 4px rgba(0, 0, 0, 0.25)',
            }}
            value={text}
            onChange={(event) => setText(event.target.value)}
          />

          <Button
            type="submit"
            disabled={!text.trim()}
            style={{ alignSelf: 'center', marginTop: 40, marginBottom: 30, width: 320 }}
          >
            Submit
          </Button>
        </form>
      </Screen.Body>
    </Screen>
  );
}
